import { App} from 'antd'
import { useTaskManageDelMutation } from '../../store/BnsKeJiApi';
import {DeleteOutlined,} from '@ant-design/icons';
function InterfaceDel(props) {
    const {modal,message} = App.useApp();
    const [submitDel] = useTaskManageDelMutation()   
    return (
        <>
            {localStorage.getItem('eu_id')===props.et_uid && <a onClick={() => {
                submitDel({et_id:props.et_id}).then((res) => {
                    // console.log(res);
                    if (res.data.Status === 'success') {
                        message.info('删除成功！');
                    }
                    if (res.data.Status === "fail") {
                        message.error('删除失败！'+res.data.Message)
                    }
                })
                // modal.confirm({
                //     title: '确定删除吗?',
                //     content: '删除后不能恢复',
                //     okText: '确认',
                //     okType: 'danger',
                //     cancelText: '取消',
                //     onOk() {
                //         submitDel({et_id:props.et_id}).then((res) => {
                //             // console.log(res);
                //             if (res.data.Status === 'success') {
                //                 message.info('删除成功！');
                //             }
                //             if (res.data.Status === "fail") {
                //                 message.error('删除失败！'+res.data.Message)
                //             }
                //         })
                //     },
                //     onCancel() {
                //         // console.log('Cancel');
                //     },
                // }); 
            }}><DeleteOutlined /> 删除接口</a>}
        </>
    )
}

export default InterfaceDel